import React, { Fragment, useCallback } from 'react'
import { useTranslation } from "react-i18next";
import './DialerContacts.css'
import AbandonedCall from '../../../../assets/ringTypes/AbandonedCall.png'
import IncomingCall from '../../../../assets/ringTypes/IncomingCall.png'
import MissedCall from '../../../../assets/ringTypes/MissedCall.png'
import OutGoingCall from '../../../../assets/ringTypes/OutGoingCall.png'
const DialerContacts = (props) => {
    const [t] = useTranslation('common')
    const appAccess = props.appAccess
    let callTypeHeb = null
    let icon = null
    if (props.callType === 'Answered') { callTypeHeb = t('Answered call'); icon = IncomingCall }
    else if (props.callType === 'Outgoing') { callTypeHeb = t('Outgoing call'); icon = OutGoingCall }
    else if (props.callType === 'Missed') { callTypeHeb = t('Missed call'); icon = MissedCall }
    else if (props.callType === 'Abandoned') { callTypeHeb = t('Abandoned Call'); icon = AbandonedCall }
    else { callTypeHeb = t('Missed call'); icon = MissedCall }
    let cardColor = 'row card dialCard'
    if (!props.selectMultipleBtnClicked && (props.callSelected._id === props._id && props.callSelected.telephone === props.clientNum.replace('+972', '0'))) {
        cardColor = 'row card dialCard chatCardOnSelect'
    }
    else if (props.selectMultipleBtnClicked && props.isCallMultiSelected) {
        cardColor = 'row card dialCard chatCardOnSelect'
    }
    let title = null
    if (!props.name) {
        title = props.clientNum.replace('+972', '0');
    }
    else {
        title = props.name;
    }
    const OnNewConvChannelSelected = props.OnNewConvChannelSelected
    const onNewConvName = props.onNewConvName
    const OnNewConvClicked = props.OnNewConvClicked
    const onChannelSelect = useCallback((channelId, msgType) => {
        OnNewConvChannelSelected(msgType)
        onNewConvName(channelId)
        setTimeout(() => OnNewConvClicked(), 0)

    }, [OnNewConvClicked, onNewConvName, OnNewConvChannelSelected])

    return (
        <Fragment>
            <div className={cardColor} onClick={props.onCallSelected}>

                <div className='col-10 col-md-9 costContactsTextCol'>
                    <div className='card-body chatCardBody'>
                        <p className='mutedP'>{props.callTime}</p>
                        <p className='contactCardTitle'>{title} </p>
                        <p className='dialCardText'> {callTypeHeb} <span className='callDuration'>{'[' + (props.duration >= 0 ? props.duration : 0).toFixed(0) + ` ${t('seconds')}]`}</span></p>
                        <div className='containerDialList'>
                            <div className='dialItem_channelsPanel'>
                                {appAccess !== 'DIALER' && <i className="fab fa-whatsapp-square dialItem_channelsPanel_whatsapp" onClick={() => onChannelSelect(props.clientNum.split('_')[0], 'whatsapp')} />}
                                {appAccess !== 'DIALER' && <i className="fas fa-sms dialItem_channelsPanel_sms margin-right--5px" onClick={() => onChannelSelect(props.clientNum.split('_')[0], 'sms')} />}
                            </div>
                            <div>
                                {props.isContactIdAvailabileCalls?._id ? <i className="fa-regular fa-pen-to-square chatContact_channelsPanel_contactList" onClick={() => props.onContactListBtnClicked('edit', 'DIALER')}></i> : <i className="fa-solid fa-plus chatContact_channelsPanel_contactList" onClick={() => props.onContactListBtnClicked('add', 'DIALER')}></i>}
                            </div>
                        </div>
                    </div>
                </div>
                <div className='col-2 col-md-3 costContactsCol'>
                    <div className='callTypeIcon'>
                        <img src={icon} onClick={props.CallBtClicked} className='callTypeImg' alt='...' />
                    </div>
                </div>
            </div>
            <hr className="dividingLineBetChats" />
        </Fragment>
    )
};

export default DialerContacts;